/**
 * Detección Tiger — misma regla que front shell + sim lab (?tigerSim=1).
 */
import { isTigerSimActive, syncTigerSimFromUrl } from './tigerSim';

syncTigerSimFromUrl();

export const isTigerAndroid = () => {
  try {
    return typeof window !== 'undefined' && !!window.Jph;
  } catch {
    return false;
  }
};

export const isTigerIOS = () => {
  try {
    return (
      typeof window !== 'undefined' &&
      !!window.webkit?.messageHandlers?.JphIOS
    );
  } catch {
    return false;
  }
};

/** True en WebView Tiger o simulación lab. */
export const isTigerEnvironment = () =>
  isTigerAndroid() || isTigerIOS() || isTigerSimActive();

export { isTigerSimActive };
